import {AccessibleGridCell} from 'constants/SampleConstants';
import {FillDirection} from 'lookup-config/LookupConfigModalConstants';
import {BenchlingAction} from 'redux-stores/Action';
import {ScanToMoveCellByCoordinates} from 'samples/grids/ScanToMoveGridUtil';
import omitKey from 'util/omitKey';

import {GridUIActionType} from './GridUIReduxActions';

export interface AllGridsUIState {
  [tabId: string]: GridUIState;
}

interface GridUIState {
  selectedCells: Array<AccessibleGridCell>;
  scanModeCells?: ScanToMoveCellByCoordinates | null;
  isScanMode: boolean;
  scanningCoordinates?: string;
  fillDirection?: FillDirection;
}

const ALL_GRIDS_UI_INITIAL_STATE = {};

const GRID_UI_INITIAL_STATE = {selectedCells: [], isScanMode: false};

function reduceGridUIByTab(state: GridUIState = GRID_UI_INITIAL_STATE, action: BenchlingAction): GridUIState {
  switch (action.type) {
    case GridUIActionType.SET_SCAN_MODE:
      return {
        ...state,
        scanningCoordinates: action.isScanMode ? state.scanningCoordinates : undefined,
        isScanMode: action.isScanMode,
      };
    case GridUIActionType.SET_SELECTED_CELLS:
      return {...state, selectedCells: action.cells};
    case GridUIActionType.SET_SCAN_MODE_CELLS:
      return {
        ...state,
        scanModeCells: action.scanModeCells,
      };
    case GridUIActionType.SET_SCANNING_COORDINATES:
      return {
        ...state,
        scanningCoordinates: action.scanningCoordinates,
      };
    case GridUIActionType.SET_FILL_DIRECTION:
      return {
        ...state,
        fillDirection: action.fillDirection,
      };
    default:
      return state;
  }
}

export default function reduceGridUI(
  state: AllGridsUIState = ALL_GRIDS_UI_INITIAL_STATE,
  action: BenchlingAction
): AllGridsUIState {
  switch (action.type) {
    case GridUIActionType.OPEN_GRID:
      return {...state, [action.gridId]: GRID_UI_INITIAL_STATE};
    case GridUIActionType.CLOSE_GRID:
      return omitKey(state, action.gridId);
    case GridUIActionType.SET_SELECTED_CELLS:
    case GridUIActionType.SET_SCAN_MODE_CELLS:
    case GridUIActionType.SET_SCAN_MODE:
    case GridUIActionType.SET_SCANNING_COORDINATES:
    case GridUIActionType.SET_FILL_DIRECTION:
      return {
        ...state,
        [action.gridId]: reduceGridUIByTab(state[action.gridId], action),
      };
    default:
      return state;
  }
}
